import {
    AppId,
    Button,
    ButtonType,
    FCX,
    getFormattedThousand, ProductLogo, sanitize,
    usePlatformContext
} from "@datassential/platform-ui-lib";
import './SectionReports.scss';
import FoodSection from "@pages/Food/components/Section/Section";
import Widget from "@components/Widget/Widget";
import { IFoodProfileDocuments } from "@models/FoodProfileDocuments";
import { useEffect } from "react";
import { FoodSectionEnum } from "@pages/Food/Food.constants";
import PublicationCard, { PublicationCardTooltip } from "@components/PublicationCard/PublicationCard";

const FoodSectionReports: FCX<{
    word: string;
    data: IFoodProfileDocuments['reports'];
    isLoading: boolean;
    setHasData: (hasData: boolean) => void;
}> = ({
    word,
    data: {
        data: {
            reports,
            totalCount,
        }
    },
    isLoading,
    setHasData,
}) => {
    const {
        userInfo: {
            products,
            reportProDetailsUrl,
            reportProMoreResultsUrl,
        },
    } = usePlatformContext();
    const productRP = products[AppId.ReportPro];

    const detailsPath = process.env.REACT_APP_RP_ITEM_LINK ?? reportProDetailsUrl;
    const moreResultsPath = process.env.REACT_APP_RP_SEARCH_LINK ?? reportProMoreResultsUrl;

    useEffect(() => {
        setHasData(!isLoading && totalCount > 0);
    }, [isLoading, totalCount, setHasData]);

    if (isLoading) {
        return (
            <div className="Food__section is-loading">
                <div className="spinner spinner-blink">
                    <ProductLogo appId={AppId.Snap} type="regular"/>
                </div>
            </div>
        );
    }

    if (!totalCount) return null;

    return (
        <div
            className="Food__section"
            id={FoodSectionEnum.Reports}
            data-testid="blockFoodSectionReports"
        >
            <FoodSection
                headerContent={(
                    <div data-testid="textFoodReportsTitle">
                        REPORTS
                    </div>
                )}
                className="appears-top del-1"
                testId="blockFoodReports"
            >
                <Widget className="FoodSectionReports">
                    <div className="FoodSectionReports__content">
                        {reports.map((report, index) => (
                            <PublicationCard
                                key={report.id}
                                data={report}
                                index={index}
                                link={`${productRP.url}${detailsPath}${report.id}`}
                                tooltipId={`FP-reports-item-${report.id}`}
                                testIdBase="FoodReportsItem"
                            />
                        ))}

                        <Button
                            type={ButtonType.Anchor}
                            link={sanitize(`${productRP.url}${moreResultsPath}${word}`)}
                            className="FoodSectionReports__button"
                            data-testid="buttonFoodReportsAllResultsExternalLink"
                        >
                            view all {getFormattedThousand(totalCount)} documents
                        </Button>
                    </div>
                    {reports.map((report, index) => (
                        <PublicationCardTooltip
                            key={report.id}
                            data={report}
                            index={index}
                            tooltipId={`FP-reports-item-${report.id}`}
                            testIdBase="FoodReportsItem"
                        />
                    ))}
                </Widget>
            </FoodSection>
        </div>
    );
};

export default FoodSectionReports;